import { render, staticRenderFns } from "./CustomMediaControls.vue?vue&type=template&id=816482ea"
import script from "./CustomMediaControls.vue?vue&type=script&lang=js"
export * from "./CustomMediaControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports